<template >
  <!-- <div id="app"> -->
    <v-app id="app" class="grey lighten-4">
     <H1 class="printOnly">WW2 database</H1>
      <page-header />

      <!-- not sure what this does kkf 24mar19 main -->
      
      <v-container fluid pl-3>
        <router-view :key="$route.fullPath"></router-view>
      </v-container>
       
      <!-- /main -->

      <v-footer fixed height="auto" color="indigo darken-3"  >
        <v-layout  row wrap py-2  white--text>
          <v-flex   text-xs-left  xs8>
            <v-btn v-for="link in links" v-on:click.native="$navigateTo(link.r)"
            :key="link.n" color="white"  flat>
            {{ link.n }}  
            </v-btn>
          </v-flex>
          <v-flex   text-xs-right  xs4 px-2 mt-3  >
             <span style='font-size:66%;padding-right:3em;'>2Jul26</span>  &copy;2026 — <strong>UNSW Canberra</strong>
          </v-flex>
        </v-layout>      
      </v-footer>

    </v-app>
    
  <!-- </div> -->
</template>

<script>
import PageHeader from '@/components/Header.vue'
export default {
  name: 'app',
  data: () => ({
    links: [
      {n: 'Home', r: 'home'},
      {n: 'About', r: 'about'},
      {n: 'Contact Us', r: 'contact'}
    ]
  }),
  components: {
    PageHeader
  },
  methods: {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  
  @media screen {
    .printOnly { display: none !important; }
    
  }
  /* Styles applied only when printing */
  @media print {
    body {
      background-color: white; /* Ensure white background for printing */
      color: black; /* Ensure black text for readability */
      font-size:80% !important;
    }

    /* Hide elements not needed in print */
    .sidebar, .footer, .v-toolbar--fixed, .v-footer, button {
      display: none !important;
    }

    .printOnly {
      margin-left:1em; background-color: white;  text-align: left !important; font-size:120%
    }

    .application--wrap {
      background-color: white !important;
      color:black !important ;
      margin-top:-40px !important;
    }

    .container, .application--wrap {
      background-color: white !important;
      color:black !important ;
    }
    .v-toolbar__content {
      background-color: white !important;
    }

    .v-toolbar__title {
      background-color: white !important;
      color:black !important ;
      text-align: center !important;
      font-size:200% !important ;
      width:100%
    }

    /* Adjust layout for print */
    .content {
      width: 50%;
      margin: 0;
    }
  }
}
.prompt {text-align:left;font-weight: bold; font-size:110%}

</style>



// WEBPACK FOOTER //
// src/App.vue